export enum UserRole {
    User = "User",
    CompanyAdministrator = "CompanyAdministrator",
    Administrator = "Administrator",
}
